import React from 'react';

const ListenButton: React.FC<{ text: string }> = ({ text }) => {
  const speak = () => {
    if ('speechSynthesis' in window) {
      const utter = new window.SpeechSynthesisUtterance(text);
      utter.lang = 'en-US';
      window.speechSynthesis.speak(utter);
    } else {
      alert('Sorry, your browser does not support text-to-speech.');
    }
  };

  return (
    <button
      onClick={speak}
      title="Listen"
      className="ml-2 text-blue-600 hover:text-pink-500 focus:outline-none inline-flex items-center transition-colors duration-200"
      style={{ fontSize: '1.5em', verticalAlign: 'middle' }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="28" height="28">
        <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3a4.5 4.5 0 0 0-1.5-3.36v6.72A4.5 4.5 0 0 0 16.5 12zm2.5 0c0-2.5-1.5-4.71-3.5-5.65v2.13c1.2.7 2 2.07 2 3.52s-.8 2.82-2 3.52v2.13c2-.94 3.5-3.15 3.5-5.65z"/>
      </svg>
    </button>
  );
};

export default ListenButton; 